import React from 'react';
import Proximamente from '../components/Proximamente';
import Navbar from '../components/Navbar';
import DashboardComponent from '../components/DashboardComponents/DashboardComponent';

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-blanco-nieve text-gris-oscuro">
      <Navbar />
      <div className="container mx-auto p-4">
        <DashboardComponent />
      </div>
    </div>
  );
};

export default Dashboard;